export default "__VITE_ASSET__CPYnuCEK__"